import React, { Component } from "react";
import { Route } from "react-router-dom";
import "./style.css";
import Jumbo from "./Jumbotron";
import Differentiators from "./Differentiators";
import Courses from "./Courses";
import JobGuarantee from "./JobGuarantee";
import JobGuaranteeMobile from "./JobGuarantee/JobGuaranteeMobile/jobGuaranteeMobile";
import Testimonials from "./Testimonials";
import Events from "./Events";
import { Helmet } from "react-helmet";

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDesktop: false
    };

    this.updateSize = this.updateSize.bind(this);
  }

  componentDidMount() {
    this.updateSize();
    window.addEventListener("resize", this.updateSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateSize);
  }

  updateSize() {
    this.setState({ isDesktop: window.innerWidth > 1024 });
  }

  render() {
    return (
      <Route>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>

        <div className="all-pages">
          <Jumbo isDesktop={this.state.isDesktop} />

          {/* <Logos /> */}

          <Differentiators />

          <Courses />

          {this.state.isDesktop ? <JobGuarantee /> : <JobGuaranteeMobile />}

          <Testimonials />

          <Events />
        </div>
      </Route>
    );
  }
}

export default Homepage;
